export const genders = [
    { option: 'male', label: "Male" },
    { option: 'female', label: "Female" },
    { option: 'neutral', label: "Neutral" },
    { option: 'none', label: "Not available" }
]